import { gql, useQuery } from '@apollo/client'
import { useEffect, useMemo } from 'react'

import {
  FirstComeFirstServedCompleteQuery,
  FirstComeFirstServedCompleteQueryVariables,
  ItemType,
  UserCartTransactionOrderFragmentDoc,
} from '@/clients/utoniq-core/schema'
import { makeViewModel } from '@/core/architecture'
import { removePrefernce } from '@/core/native/storage'
import { useRouter } from '@/core/router'

import { Action, State } from './template'
/**
 *
 */
export const useViewModel = makeViewModel<State, Action>(() => {
  const { router } = useRouter<{
    cartTransactionOrderId?: string
    artistId?: string
    itemId?: string
  }>()
  const cartTransactionOrderId = router.query.cartTransactionOrderId
  const { data, loading } = useQuery<
    FirstComeFirstServedCompleteQuery,
    FirstComeFirstServedCompleteQueryVariables
  >(QUERY, {
    skip: !cartTransactionOrderId,
    variables: {
      userCartTransactionOrderId: cartTransactionOrderId ?? '#',
    },
  })

  const isShowUsageTicketNote = useMemo<boolean>(
    () =>
      !!data?.userCartTransactionOrder?.items?.some(
        item => item.item.type === ItemType.Ticket
      ),
    [data?.userCartTransactionOrder?.items]
  )

  useEffect(() => {
    ;(async () => {
      // 冪等キーを削除
      await removePrefernce('idempotencyKey')
    })()
  }, [])

  return {
    state: {
      loading,
      isKonbini: !!data?.userCartTransactionOrder.isKonbini,
      purchaseOrderId: cartTransactionOrderId ?? '#',
      pendingPurchaseId:
        data?.userCartTransactionOrder.pendingPurchaseItem?.id ?? '#',
      isShowUsageTicketNote,
      paymentType: data?.userCartTransactionOrder.paymentType ?? null,
      voucherUrl:
        data?.userCartTransactionOrder.pendingPurchaseItem?.voucherUrl ?? null,
      paymentDeadline:
        data?.userCartTransactionOrder.pendingPurchaseItem
          ?.formattedExpiredAt ?? null,
    },
    actions: {},
  }
})

const QUERY = gql`
  query FirstComeFirstServedComplete($userCartTransactionOrderId: ID!) {
    userCartTransactionOrder(id: $userCartTransactionOrderId) {
      ...UserCartTransactionOrder
    }
  }
  ${UserCartTransactionOrderFragmentDoc}
`
